import React from 'react';

import { TFunction } from 'i18next';

import { useResetFilters } from '@features/JournalEventsFilters/lib';
import { Icon, UiButton, UiText, EmptyListItemsPlaceholder } from '@shared/ui';

import cls from './NotFoundEventsPlaceholder.module.css';

interface INotFoundEventsPlaceholderProps {
    t: TFunction<'translation', undefined>;
}

export const NotFoundEventsPlaceholder = ({ t }: INotFoundEventsPlaceholderProps) => {
    const { onResetFilters } = useResetFilters();

    return (
        <EmptyListItemsPlaceholder
            className={cls.container}
            header={<Icon iconName="noFoundTasks" height={75} width={75} />}
            main={
                <>
                    <UiText tag="h3" variant="heading" weight="semibold" align="center">
                        {t('JournalEvents.EmptyEventsPlaceholder.NotFound.Header')}
                    </UiText>
                    <UiText tag="h4" variant="plain" align="center">
                        {t('JournalEvents.EmptyEventsPlaceholder.NotFound.Description')}
                    </UiText>
                </>
            }
            footer={
                <UiButton
                    startIcon={
                        <Icon iconName="paintbrush" width={14} height={14} fill="currentColor" />
                    }
                    btnText={t('JournalEvents.EmptyEventsPlaceholder.NotFound.ResetFiltersBtn')}
                    variant="text"
                    btnColor="secondary"
                    className={cls.ResetFiltersBtn}
                    onClick={onResetFilters}
                />
            }
        />
    );
};
